import { EditOutlined } from '@ant-design/icons';
import { Card, Tooltip, Button, message } from 'antd';
import { useForm } from 'react-hook-form';
import JobDetails from './JobDetails';
import JobRequirements from './JobRequirements';
import { useState } from 'react';
import { JobStatus, isInterviewer } from 'features/recruitment/jobs/components/types';
import { getUser } from 'utils/auth';
import { useTranslation } from 'react-i18next';
import CustomButton from 'styles/buttonStyled';
import styled from 'styled-components';
import { JobRequestStatus } from 'features/recruitment/jobs/components/JobsRequisitionManagementTable';
import { useAppDispatch } from 'app/hooks';
import { updateJobRequestStatus } from 'features/recruitment/recruitmentAction';
import { useHistory } from 'react-router-dom';

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
`;
const TitleText = styled.span`
  margin-right: 20px;
`;

const Summary = ({ data, handleChange, isAdminOrManager }: any) => {
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: undefined,
  });
  const { t } = useTranslation([
    'validation',
    'masterConfig',
    'setup_menu_screen',
    'insurance',
    'common',
    'overtime',
    'employee',
    'menu',
    'recruitment',
    'action',
  ]);

  const history = useHistory();
  const dispatch = useAppDispatch();

  const [visibleDetail, setVisibleDetail] = useState(false);
  const [visibleRequirement, setVisibleRequirement] = useState(false);

  const handleCopyLink = () => {
    const baseUrl = window.location.origin;
    const publicLink = `${baseUrl}/jobs/public/${data.id}`;
    navigator.clipboard
      .writeText(publicLink)
      .then(() => {
        message.success('Link copied to clipboard!');
      })
      .catch(() => {
        message.error('Failed to copy link');
      });
  };
  const contents = [
    {
      key: 'job',
      title: (
        <HeaderWrapper>
          <TitleText>{t('recruitment:job_detail')}</TitleText>
          <Button type="primary" onClick={handleCopyLink}>
            Copy Link
          </Button>
        </HeaderWrapper>
      ),
      component: (
        <JobDetails
          data={data}
          handleChange={handleChange}
          visible={visibleDetail}
          setVisible={setVisibleDetail}
          isAdminOrManager={isAdminOrManager}
        />
      ),
    },
    {
      key: 'requirement',
      title: t('recruitment:job_requirement'),
      component: (
        <JobRequirements
          data={data}
          handleChange={handleChange}
          visible={visibleRequirement}
          setVisible={setVisibleRequirement}
        />
      ),
    },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {(isInterviewer()
        ? contents.filter((content) => content.key === 'requirement')
        : contents
      ).map(({ component, title, key }) => (
        <Card
          title={title}
          bordered={false}
          headStyle={{
            fontSize: 24,
            fontWeight: 500,
          }}
          extra={
            !isInterviewer() && isAdminOrManager ? (
              <a
                onClick={() =>
                  key === 'job'
                    ? setVisibleDetail(!visibleDetail)
                    : setVisibleRequirement(!visibleRequirement)
                }
              >
                {' '}
                <EditOutlined style={{ color: '#1890FF', marginRight: 8 }} />
                {t('action:edit')}
              </a>
            ) : null
          }
        >
          {component}
        </Card>
      ))}
      {data?.status === JobStatus.APPROVED &&
        data?.jobRequestStatus !== JobRequestStatus.DONE &&
        data?.jobRequestStatus !== JobRequestStatus.CANCEL &&
        isAdminOrManager && (
          <ButtonWrapper style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Tooltip title={t('recruitment:done_job_requisition')}>
              <CustomButton
                onClick={() => {
                  dispatch(
                    updateJobRequestStatus({
                      id: data?.id,
                      body: {
                        jobRequestStatus: 'Done',
                      },
                      callBack: () => {
                        history.goBack();
                      },
                    }),
                  );
                }}
              >
                {t('action:done')}
              </CustomButton>
            </Tooltip>
            <Tooltip title={t('recruitment:cancel_job_requisition')}>
              <CustomButton
                onClick={() => {
                  dispatch(
                    updateJobRequestStatus({
                      id: data?.id,
                      body: {
                        jobRequestStatus: 'Cancel',
                      },
                      callBack: () => {
                        history.goBack();
                      },
                    }),
                  );
                }}
              >
                {t('action:cancel')}
              </CustomButton>
            </Tooltip>
          </ButtonWrapper>
        )}
    </div>
  );
};

export default Summary;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: right;
  gap: 10px;
  margin-bottom: 15px;
`;
